exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overflowHidden>p{margin-left:10px;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;border:1px solid #ccc}", ""]);

// exports
